
import appConfig from "../configs/app.config";
import moment from "moment-timezone";
import TokenService from '@/services/token.service';

import { arrayTitle } from "@shared/config";

export default {
  methods: {
    async getP(p){
      try{
        return await TokenService.getUser().top_permissions[p];
      }catch(e){
        console.error("Get permission error "+e);
        return false
      }
    },
    url(str) {
      
      if (!str) return '';
      return appConfig.APP_API.replace('api/','') + str.replace(/^\//, '');
    },
    cookies() {
      return this.$cookies;
    },
    clone(ob) {
      return JSON.parse(JSON.stringify(ob));
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$root.showToast("Copy success");
      } catch (err) {
        this.$root.showToast("Copy fail", { type: "error" });
      }
    },
    getDataSafely(data, path) {
      try {
        let x = (
            path.split(".").reduce((acc, part) => acc && acc[part], data) || null
        );

        return x;
      } catch (e) {
        return null;
      }
    },
    upload(file, patch) {
      
      return appConfig.APP_UPLOAD + (patch ? patch + "/" : "") + file;
    },

    prettyJSON: function (value) {
      try {
        value = JSON.stringify(JSON.parse(value), null, 2);
      } catch (_) {
        return value;
      }
    },
    stt(index, page, perpage) {
      return index + 1 + (page - 1) * perpage;
    },
    _e(str) {
      return str.replaceAll(" ", "_").replaceAll(".", "_");
    },
    _parseInt(value, defaultValue) {
      const parsedValue = parseInt(value);
      return isNaN(parsedValue) ? defaultValue : parsedValue;
    },
    _t($s) {
      return this.$t($s);
    },

    findRouterByName(routers, name) {
      let foundRouter = null;

      function search(router) {
        if (router.name === name) {
          foundRouter = router;
          return true;
        }

        if (router.children && router.children.length > 0) {
          for (const child of router.children) {
            if (search(child)) {
              return true;
            }
          }
        }

        return false;
      }

      routers.forEach((router) => {
        if (!foundRouter) {
          search(router);
        }
      });

      return foundRouter;
    },

    changeParams(router, newParams) {
      const currentRoute = router.currentRoute.value;
      const query = { ...currentRoute.query, ...newParams };
      router.replace({ query: query }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    addLoading(obj) {
      const newDiv = document.createElement("div");
      newDiv.classList = "wrap-loading";
      newDiv.innerHTML =
          '<div class="spinner-border text-primary avatar-sm" role="status"><span class="visually-hidden">Loading...</span></div>';
      obj.appendChild(newDiv);
      obj.classList.add("show-loading");
    },
    removeLoading(obj) {
      const elementsToRemove = obj.getElementsByClassName("wrap-loading");
      while (elementsToRemove.length > 0) {
        elementsToRemove[0].parentNode.removeChild(elementsToRemove[0]);
      }
      obj.classList.remove("show-loading");
    },
    generateCode(data) {
      if (!data || !data.begin || !data.length || !data.pattern) {
        return null;
      }
      let code = data.pattern + String(data.begin).padStart(data.length, "0");
      return code;
    },
    checkVariable(key, data) {
      let keys = key.split(".");
      let temp = data;
      for (let k of keys) {
        if (temp != undefined && Object.hasOwn(temp, k)) {
          temp = temp[k];
        } else {
          return false;
        }
      }
      return true;
    },
    getGender(gender = false, has_value = false) {
      let genderList = [
        {
          id: "male",
          name: this.$t("male"),
        },
        {
          id: "female",
          name: this.$t("female"),
        },
        {
          id: "unknown",
          name: this.$t("unknown"),
        },
      ];

      if (gender === false) {
        if (has_value == false) return genderList;
        return "";
      } else {
        let matchedGender = genderList.find((item) => item.id === gender);
        return matchedGender ? matchedGender.name : "";
      }
    },
    isImageMIME(mimeType) {
      var pattern =
          /^(image\/bmp|image\/gif|image\/jpeg|image\/png|image\/tiff|image\/webp)$/;
      return pattern.test(mimeType);
    },
    timeAgo(postedDate) {
      const now = new Date();
      const seconds = Math.floor((now - new Date(postedDate)) / 1000);
      const intervals = [
        { label: this.$t("nam"), seconds: 31536000 },
        { label: this.$t("thang"), seconds: 2592000 },
        { label: this.$t("tuan"), seconds: 604800 },
        { label: this.$t("ngay"), seconds: 86400 },
        { label: this.$t("gio"), seconds: 3600 },
        { label: this.$t("phut"), seconds: 60 },
        { label: this.$t("giay"), seconds: 1 },
      ];

      for (const interval of intervals) {
        const count = Math.floor(seconds / interval.seconds);
        if (count >= 1) {
          return `${count} ${interval.label} ${this.$t("truoc")}`;
        }
      }
      return this.$t("vuaxong");
    },
    getTitle(type = null) {
      const item = arrayTitle.find((item) => item.type === type);
      return item ? item.title : "";
    },
    getValuebycode(code = null, array) {
      const item = array.find((item) => item.code === code);
      return item ? item.name : "";
    },
    combineDateTime(date, time) {
      if (date && time) {
        const combined = new Date(date);
        combined.setHours(time.getHours());
        combined.setMinutes(time.getMinutes());
        combined.setSeconds(0);
        return combined;
      }
      return date;
    },
    combineDateTime7(date, time) {
      if (date && time) {
        const combined = new Date(date);
        combined.setHours(time.getHours()+7);
        combined.setMinutes(time.getMinutes());
        combined.setSeconds(0);
        return combined;
      }
      return date;
    },
    combineDate(date) {
      // Kiểm tra nếu đầu vào không phải là đối tượng Date, trả về null
      if (!(date instanceof Date)) {
        return null;
      }

      // Lấy phần ngày (YYYY-MM-DD)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0, nên phải +1
      const day = String(date.getDate()).padStart(2, "0");

      // Lấy phần giờ (HH:MM:SS)
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

      // Kết hợp các phần để tạo chuỗi định dạng ISO 8601
      const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;

      return isoString;
    },
    convertToValidDate(dateString) {
      // Replace the space between the date and time with a 'T' to comply with ISO 8601 format
      const formattedDateString = dateString.replace(" ", "T");
      // Create a new Date object
      const date = new Date(formattedDateString);

      return date;
    },
    extractLetters(str='') {
      if(!str) return '';
      const words = (str ?? "")?.split(" ");
      let firstLetter = "";
      let lastLetter = "";
      if (words?.length > 0) {
        firstLetter = words[0].charAt(0);
      }
      if (words?.length > 1) {
        lastLetter = words[words.length - 1].charAt(0);
      }
      return `${firstLetter}${lastLetter}`.toLowerCase();
    },
    toBoolean(val) {
      return !!JSON.parse(String(val).toLowerCase());
    },
    getStatusInfo(status) {
      const text = status ? this.$t("khadung") : this.$t("khongkhadung");
      const className = status
          ? "badge border border-success  text-success"
          : "badge border border-danger  text-danger";
      return {
        text,
        className,
      };
    },
    dataSelect(data, is_status = true) {
      data = data.filter((item) => {
        item["text"] = item["name"];

        if (is_status == true) {
          return item["status"] !== 0 && item["status"] !== false;
        } else {
          return item;
        }
      });

      return data;
    },
    parseBoolean(value) {
      // Nếu giá trị là một chuỗi, kiểm tra xem nó có phải là "true" không (không phân biệt hoa thường)
      if (typeof value === "string") {
        return value.trim().toLowerCase() === "true";
      }
      // Nếu giá trị là một số, trả về true nếu nó khác 0, và false nếu nó là 0
      else if (typeof value === "number") {
        return value !== 0;
      }
      // Nếu giá trị là một boolean, trả về giá trị ban đầu
      else if (typeof value === "boolean") {
        return value;
      }
      // Trong các trường hợp còn lại, trả về false
      else {
        return false;
      }
    },

    syncData(arrayData, fields) {
      arrayData.forEach((data) => {
        fields.forEach((field) => {
          if (
              data &&
              field in data &&
              (data[field] === 1 || data[field] === 0)
          ) {
            data[field] = data[field] === 1 ? true : false;
          }
        });
      });
      return arrayData;
    },
    VNTDateFormatV2(data  , format = "DD-MM-YYYY"){

      return this.VNTDateFormat(data,format,false)
    },
    VNTDateFormat(data, format = "DD-MM-YYYY",toDate=true) {

      if (!data) {
        return null;
      }
      if (Array.isArray(data)) {
        return data.map((item) => {
          let parsedDate = moment(item);
          if (!parsedDate.isValid()) {
            parsedDate = moment(item,['DD-MM-YYYY', 'MM-DD-YYYY']);
            if (!parsedDate.isValid()) {
              return null;
            }
          }
          if(toDate)
            return moment(parsedDate.tz("Asia/Bangkok").format(format), format).toDate();
          return parsedDate.tz("Asia/Bangkok").format(format);
        });
      }
      let parsedDate = moment(data);
      if (!parsedDate.isValid()) {
        parsedDate = moment(data,"DD-MM-YYYY","MM-DD-YYYY");
        if (parsedDate.isValid()) {
          return parsedDate.tz("Asia/Bangkok").format(format);
        }else{
          return null;

        }
      }
      if(toDate)
        return moment(parsedDate.tz("Asia/Bangkok").format(format), format).toDate();
      return parsedDate.tz("Asia/Bangkok").format(format);
    },

    imageLink(str) {
      return appConfig.APP_UPLOAD + str;
    },
    currentRouter() {
      return this.$router.history.current.path;
    },
    convertObjectToOptions(data, def = true) {
      var result = {};
      if (def == true) {
        result[0] = this.$t("vuilongchon");
      }
      data.forEach((item) => {
        result[item.id] = item.name;
      });

      return result;
    },
    findValueByField(data, id, field) {
      const foundItem = data.find((item) => item.id === id);

      return foundItem ? foundItem[field] : null;
    },
    formatNumDate(num) {
      // Kiểm tra nếu số là số nguyên
      if (Number.isInteger(num)) {
        return num.toFixed(0); // Hiển thị dưới dạng số nguyên
      }
      return num; // Hiển thị dưới dạng thập phân
    },
    formatMoney(num, unit = "VND") {
      if (isNaN(num)) return "Invalid number";

      // Định dạng số với dấu phân tách hàng nghìn và không có chữ số thập phân
      const formattedNumber = Math.floor(num).toLocaleString("vi-VN");

      // Kiểm tra nếu unit không được xác định hoặc null, gán giá trị mặc định
      const formattedUnit = unit ? unit.toLowerCase() : "vnd";

      // Thêm đơn vị tiền tệ ở cuối
      return `${formattedNumber} ${formattedUnit}`;
    },

    buildURL(apiURL, options) {
      let url = new URL(this.getApiUrl(apiURL));
      let params = new window.URLSearchParams(window.location.search);

      const keys = Object.keys(options);

      keys.forEach((key) => {
        if (options[key] != "" && Request.allowRequest.includes(key))
          params.set(key, options[key]);
        else params.delete(key);
      });

      url.search = params;
      return url;
    },
    getApiUrl(str) {
      let url = api.defaults.baseURL + str;
      return url.replace(/([^:]\/)\/+/g, "$1");
    },
    toggleLoading(elm) {
      const parent = elm || document.body;
      const loader = Array.from(parent.children).find(child => child.classList.contains('elmLoader'));
      
      if (loader) {
        parent.removeChild(loader);
        parent.classList.remove('loading');
      } else {
        const loaderDiv = document.createElement('div');
        loaderDiv.classList.add('elmLoader');
        loaderDiv.innerHTML = `
          <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        `;
        parent.appendChild(loaderDiv);
        parent.classList.add('loading');
      }
    },
  },
};
